export default __webpack_public_path__ + "../staticImages/weihnachten-260.png";